import React, { Component } from 'react'
import {Container} from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../principal/containers/DataWrapper";
import AcompServicosStore from "../stores/AcompServicosStore";
import AcompanhamentoServicosService from "../../../services/AcompanhamentoServicosService";
import FiltrosAcompServicos from "../components/FiltrosAcompServicos";
import {TabelaAcompServicos} from "../components/TabelaAcompServicos";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import FooterOptions from "../../comum/components/FooterOptions";
import IconButton from "../../comum/components/IconButton";
import ExportarExcelServicos from "../components/ExportarExcelServicos";
import {makePDF} from "../../../utils/formatar";
import ModalDocumentos from "../components/ModalDocumentos";


@inject("store")
@DataWrapper
@observer
export class AcompanhamentoServicos extends Component {
    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.service = new AcompanhamentoServicosService();
        this.controller = new AcompServicosStore(this.service);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Acompanhamento de Serviços");
    };

    render() {
        let pdfData = this.controller.colunasExportacao;
        const pdfDataTime = pdfData.filter(elem => elem.formatter && elem.formatter.name === 'formatarDataCustomHTML');
        return (
            <div className="form-wrapper">
                <Container className="acompanhamento-servicos" fluid>
                    <FiltrosAcompServicos controller={this.controller} service={this.service} />
                    <TabelaAcompServicos controller={this.controller} service={this.service} />
                    <ModalDocumentos controller={this.controller} />
                </Container>

                <Footer>
                    <FooterContent>
                        <div className="justify-content-between">
                            <div>
                                <b>{this.controller.items.length}</b> Registros no Total
                                { this.controller.estadoFiltros
                                && <React.Fragment>
                                    - <a onClick={ () => this.controller.reListar() } >Atualizar Lista</a>
                                </React.Fragment>
                                }
                            </div>
                        </div>
                    </FooterContent>
                    <FooterOptions>
                        <div>
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.controller.servicosLista.length===0}
                                onClick={
                                    () => makePDF(
                                        this.controller.servicosLista,
                                        pdfData.map(elem => elem.dataField),
                                        pdfData.map(elem => elem.text),
                                        pdfDataTime.map(elem => elem.dataField),
                                        true,
                                        false,
                                        {qtdColFixo: "A2", nomeDoArquivo: "AcompanhamentoDeServiços.pdf"}
                                    )
                                }
                            />
                        </div>
                        <div>
                            <ExportarExcelServicos controller = {this.controller} />
                        </div>
                    </FooterOptions>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamentoservico/telas/AcompanhamentoServicos.js